import { camelCase } from 'lodash'

export function convertConstraints(arr) {
    return Object.fromEntries(arr.map(datum => [camelCase(datum.featureProduct.featureType), datum]))
}
